{
  "travelExtras": {
    "heading": "Add last minute extra comfort",
    "removeAll": "Remove all",
    "removeAllModal": {
      "title": "Remove all unpaid travel extras",
      "text": "Anything you've already paid for stays in your booking."
    },
    "unpaidItems": {
      "title": "Your travel extras are reserved for 15 minutes",
      "text": "Pay or remove them to get your boarding pass."
    }
  },
  "meta": {
    "travelExtras": {
      "title": "Manage booking - Add travel extras"
    }
  },
  "checkIn": {
    "technicalStop": {
      "tag": "Technical stop",
      "routes": {
        "helMel": {
          "offboardingNotice": "There is a technical stop in Bangkok. You'll need to step out of the aircraft and go through the security check during the stop.",
          "secondLegNotice": "Please have your Bangkok–Melbourne boarding pass ready for the security check during the technical stop in Bangkok.",
          "viewInstructions": "View instructions",
          "instructions": {
            "title": "During the stop in Bangkok",
            "body": "<li>You'll need to step out of the aircraft</li><li>Take all carry-on baggage with you</li><li>Follow the signs to the security check point and have your BKK–MEL boarding pass ready</li><li>Head straight to the departure gate</li><li>Prepare for a carry-on baggage security check at the gate</li><li>Don't bring any liquids over 100 ml back on board</li>",
            "linkText": "Read more"
          }
        },
        "melHel": {
          "offboardingNotice": "There is a technical stop in Bangkok. You'll need to step out of the aircraft and go through the security check during the stop.",
          "secondLegNotice": "Please have your Bangkok–Helsinki boarding pass ready for the security check during the technical stop in Bangkok.",
          "viewInstructions": "View instructions",
          "instructions": {
            "title": "During the stop in Bangkok",
            "body": "<li>You'll need to step out of the aircraft</li><li>Take all carry-on baggage with you</li><li>Follow the signs to the security check point and have your BKK–HEL boarding pass ready</li><li>Head straight to the departure gate</li>",
            "linkText": "Read more"
          }
        }
      }
    }
  },
  "modifyYourTrip": {
    "changeOfPlans": {
      "notification": {
        "contactCustomerService": "Please contact our <a href=\"https://www.finnair.com/en/customer-care-and-contact-information\" target=\"_blank\"><strong>customer service</strong></a> to help you change your flights."
      },
      "message": {
        "upgradedFlights": {
          "partial": "<strong>Because you have upgraded some of your flights</strong>, changes need to go through an agent to keep your travel class. Start a chat for free with Sisu AI assistant to connect with one.",
          "plural": "<strong>Because you have upgraded your flights</strong>, changes need to go through an agent to keep your travel class. Start a chat for free with Sisu AI assistant to connect with one.",
          "singular": "<strong>Because you have upgraded your flight</strong>, changes need to go through an agent to keep your travel class. Start a chat for free with Sisu AI assistant to connect with one."
        }
      }
    }
  }
}
